import HeaderButtons from '@components/shared/Header/components/HeaderButtons';
import { PlanCardType } from '@lib/sanity/queries/modules/pricingMain/types';
import Container from '@ui/Container/Container';
import { usePricingFrequency } from '../PricingMain/PricingFrequencyContext';
import { setPlanCodeCookie } from './utils/setPlanCodeCookie';

type Props = {
  planCard: PlanCardType;
  isMobile?: boolean;
};

const PlanCTAButton = ({ planCard }: Props) => {
  const { isYearlyFrequency } = usePricingFrequency();

  const savePlanCode = () => {
    let planCodeWithFrequency;
    if (planCard.planCode === 'enterprise') {
      planCodeWithFrequency = 'team-monthly';
    } else if (planCard.planCode === 'free') {
      planCodeWithFrequency = 'automate-monthly';
    } else {
      planCodeWithFrequency = `${planCard.planCode}-monthly`;
    }
    // Expires in 30 minutes
    setPlanCodeCookie('planCode', planCodeWithFrequency, 30, '/');
  };

  const shouldApplyDiscount = () => {
    if (!planCard.discount) {
      return false;
    }
    const { discountFrequency } = planCard.discount;
    return (
      discountFrequency === 'both' ||
      (isYearlyFrequency && discountFrequency === 'yearly') ||
      (!isYearlyFrequency && discountFrequency === 'monthly')
    );
  };

  return (
    <Container theme={planCard.theme} removeContainer>
      <div onClick={savePlanCode} className="w-full">
        {shouldApplyDiscount() && planCard.discount ? (
          <Container theme={planCard.discount.theme} removeContainer>
            <HeaderButtons
              buttonPrimary={planCard.discount.buttonPrimary}
              buttonSecondary={planCard.discount.buttonSecondary}
              buttonClassName="text-black"
              className="flex w-full flex-col gap-4 sm:flex-col"
            />
          </Container>
        ) : (
          <HeaderButtons
            buttonPrimary={planCard.buttonPrimary}
            buttonSecondary={planCard.buttonSecondary}
            buttonClassName="text-black"
            className="flex w-full flex-col gap-4 sm:flex-col"
          />
        )}
      </div>
    </Container>
  );
};

export default PlanCTAButton;
